// Packages
import { createApp } from 'vue';

// Modules
import getMedia from '@helpers/breakpoints';
import { applyOfferCodes } from '@modules/quoteLinks';

// Vue components
import HeaderSearch from '@vue-components/HeaderSearch.vue';

const isDesktopMedia = getMedia('lg');

export default function init(): void {
  const header = document.querySelector<HTMLElement>('#js-header')!;

  // Create Vue instance for header
  const vueInstance = createApp({
    name: 'HeaderInstance',
    compilerOptions: {
      delimiters: ['${', '}'],
    },
    components: {
      HeaderSearch,
    },
    data() {
      return {
        isDesktop: isDesktopMedia.matches,
        isMobileSearchEnabled: false,
        isMobileNavEnabled: false,
        openDropdowns: [],
      };
    },
    created() {
      // Make isMobile responsive
      isDesktopMedia.addEventListener
        ? isDesktopMedia.addEventListener('change', this.isDesktopMediaListener)
        : isDesktopMedia.addListener(this.isDesktopMediaListener);
    },
    mounted() {
      this.applyOfferCodes();
    },
    updated() {
      this.applyOfferCodes();
    },
    beforeUnmount() {
      isDesktopMedia.removeEventListener
        ? isDesktopMedia.removeEventListener('change', this.isDesktopMediaListener)
        : isDesktopMedia.removeListener(this.isDesktopMediaListener);
    },
    methods: {
      applyOfferCodes() {
        applyOfferCodes([...header.querySelectorAll<HTMLAnchorElement>('.quote-link')]);
      },
      isDesktopMediaListener(media: MediaQueryListEvent) {
        this.isDesktop = media.matches;
      },
      toggleDropdown(id: number | string, force?: boolean) {
        const open = force === undefined ? !this.openDropdowns.includes(id) : force;

        if (open) {
          this.openDropdowns.push(id);
        } else {
          this.openDropdowns = this.openDropdowns.filter(
            (dropdown: number | string) => dropdown !== id,
          );
        }
      },
      isDropdownOpen(id: number | string) {
        return this.openDropdowns.includes(id);
      },
    },
  });

  // Mount the app
  vueInstance.mount(header);
}
